import React from 'react';
import { useLocation } from 'react-router';
import Header from 'Components/Header';
import { WrapperProps } from 'Interfaces/Common';

function SignUpSecondStepWrapper({ children }: WrapperProps) {
  const location = useLocation();

  return (
    <div className="main-layout main-layout--relative">
      <Header location={location} isActionHidden headerClassName="main-layout__header" />
      <div className="main-layout__withOutSidebar">{children}</div>
    </div>
  );
}

export default SignUpSecondStepWrapper;
